import {Component, Mixins} from 'vue-property-decorator'
import onLocaleChangeMixin from "@/mixins/onLocaleChangeMixin";
import {IOrder} from "@/entities";
import {updateItem} from "@/lib";

@Component
class orderByTokenMixin extends Mixins(onLocaleChangeMixin) {

  protected data?: IOrder | null = null;
  get order(): IOrder | any {
    return this.data;
  }
  set order(value: IOrder | any) {
    const order = this.data;
    if (order) {
      order.update({
        ...order,
        ...value
      });
    }
  }

  get title(): string {
    let order = this.order;
    return this.$t('order.title') + (order ? (' #' + order.id) : '');
  }

  protected fetching: boolean = false;

  protected initFetches: Function[] = [
    this.fetchOrderByToken
  ];

  protected reFetches = [
    this.updateOrder
  ];

  private updateOrder(): void {
    let order = this.data;
    if (order) {
      updateItem<IOrder>(order, this.$storage.actions.getOrderByToken, 'token', true);
    }
  }

  private notFound: boolean = false;

  get token(): string {
    return this.$route.params.token || '';
  }

  get secret(): string {
    return this.$route.query.secret as string || '';
  }

  protected fetchOrderByToken(): Promise<IOrder | undefined> {
    return new Promise<IOrder | undefined>((resolve, reject) => {
      this.fetching = true;
      this.$storage.actions.getOrderByToken({
        key: this.token,
        config: {
          params: {
            secret: this.secret
          }
        }
      })
        .then(res => {
          this.data = res;
          resolve(res);
        })
        .catch((reason) => {
          this.notFound = true;
          reject(reason);
        })
        .finally(() => {
          this.fetching = false;
        });

    });
  }

}

export default orderByTokenMixin
